@if (invalidTimezone) {
    <div class="invalidtimezone">
        <div>Periodeverrekening is geblokkeerd omdat tijdzone van computer niet juist is ingesteld.</div>
    </div>
}

@if (loading.length && !print) {
    <div class="loading-data">
        <div class="loading-text">
            <span>Gegevens ophalen</span>

            @if (loadingRange) {
                <small>
                    {{ loadingRange.beginDate | date: 'd MMM yyyy' }} t/m
                    {{ loadingRange.endDate | date: 'd MMM yyyy' }}
                </small>
            }
        </div>

        <div class="loading-sources">
            @for (item of loading; track item.source) {
                <span class="source">{{ item.label }}</span>
            }
        </div>

        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
}

<div class="weeks" [class.print]="print" [class.settling]="settling">
    <div class="head">
        <div class="part">
            <div class="cell wide">Dag</div>
            <div class="cell wide">Datum</div>
            <div class="cell wide">Invulling</div>
        </div>

        <div class="part me-0">
            <div class="cell">Start</div>
            <div class="cell">Stop</div>
            <div class="cell">Onderbreking</div>
            <div class="cell">Uren</div>
            <div class="cell">Pauze</div>
            <div class="cell">Uren te verrekenen</div>
        </div>

        <div class="buttons">
            @if (!print && canResettle) {
                <div
                    class="settle-week"
                    matTooltip="Al verstuurde weken opnieuw verrekenen en verschillen corrigeren"
                    (mouseover)="hoverWeekButton = 'resettle'"
                    (mouseout)="hoverWeekButton = null">
                    <button
                        [disabled]="resettling || settling || loading.length > 0"
                        (click)="resettlePeriod()"
                        color="primary"
                        mat-icon-button>
                        @if (!resettling) {
                            <i class="fa-light fa-rotate"></i>
                        } @else {
                            <i class="fa-light fa-spinner fa-spin"></i>
                        }
                    </button>
                </div>
            }
            <div
                class="week-button"
                [matTooltip]="settling ? 'Stoppen na huidige week' : 'Hele periode verrekenen'"
                (mouseover)="hoverWeekButton = 'all'"
                (mouseout)="hoverWeekButton = null">
                @if (!print) {
                    <button
                        [color]="settling ? 'warn' : 'primary'"
                        [disabled]="!settling && loading.length > 0"
                        (click)="settling ? cancelSettlePeriodHours() : settlePeriodHours()"
                        mat-icon-button>
                        @if (!settling) {
                            <i class="fa-light fa-calendars"></i>
                        } @else {
                            <i class="fa-light fa-xmark"></i>
                        }
                    </button>
                }
            </div>
        </div>

        <div class="part">
            <div class="cell">Reeds uitbetaald</div>
            <div class="cell">Nog te verrekenen</div>
            <div class="cell">Aanvulling</div>
            <div class="cell">Reistijd</div>

            @if (showTravelTo) {
                <div class="cell location">Naar locatie</div>
            }

            @if (!caoBouwInfra) {
                <div class="cell">Reiskosten</div>
            }
        </div>

        <div class="part">
            @if (caoBouwInfra) {
                <div class="cell">Toeslag 30%</div>
            }

            @if (environment.periodSettlementColums['135V'] && !caoBouwInfra) {
                <div class="cell">Toeslag 35%</div>
            }

            @if (environment.periodSettlementColums['145V'] && !caoBouwInfra) {
                <div class="cell">Toeslag 45%</div>
            }

            <div class="cell">Toeslag 50%</div>

            @if (environment.periodSettlementColums['200V']) {
                <div class="cell">Toeslag 100%</div>
            }
        </div>

        <div class="part">
            @if (environment.periodSettlementColums[100]) {
                <div class="cell">Overuren 100%</div>
            }

            @if (environment.periodSettlementColums[125] && caoBouwInfra) {
                <div class="cell">Overuren 125%</div>
            }

            <div class="cell">Overuren 130%</div>

            @if (environment.periodSettlementColums[135] && !caoBouwInfra) {
                <div class="cell">Overuren 135%</div>
            }

            @if (environment.periodSettlementColums[145] && !caoBouwInfra) {
                <div class="cell">Overuren 145%</div>
            }

            @if (environment.periodSettlementColums[150]) {
                <div class="cell">Overuren 150%</div>
            }

            <div class="cell">Zaterdag 150%</div>

            @if (environment.periodSettlementColums['200Z']) {
                <div class="cell">Weekend 200%</div>
            }

            <div class="cell">
                @if (environment.periodSettlementColums['200']) {
                    Overuren
                } @else if (environment.periodSettlementColums['Z']) {
                    Zondag
                }
                200%
            </div>
        </div>
    </div>

    @for (week of weeks; track week.weeknumber) {
        <div class="week" [class.settling]="week.settling">
            <div class="weeknumber">Week {{ week.weeknumber }}</div>
            <div class="days">
                @for (
                    day of week.weekDays;
                    track day.date;
                    let dayIndex = $index;
                    let first = $first;
                    let last = $last
                ) {
                    @for (fg of [day.fg, day.fgSecond]; track fg; let index = $index) {
                        @if (
                            fg.value.dayType || (!day.fg.value.dayType && !day.fgSecond.value.dayType && index === 0)
                        ) {
                            @let dayDisabled =
                                environment.periodType === PeriodType.Month &&
                                (beginDate.getTime() > day.date.getTime() || day.date.getTime() > endDate.getTime());

                            <div
                                class="day"
                                [class.disabled]="dayDisabled"
                                [class.settling]="day.settling"
                                [class.resettle-required]="day.resettleRequired"
                                [class.paid]="day.sendToAfas"
                                [class.open-corrections]="day.hasOpenCorrections"
                                [class.show-detail]="day === dayDetail"
                                [class.weekend]="dayIndex >= 5"
                                [matTooltipDisabled]="!day.resettleRequired"
                                [matTooltipPositionAtOrigin]="true"
                                (contextmenu)="showDayDetails($event, day)"
                                matTooltip="Er zijn aanpassingen gedaan aan de uren na de laatste verloning. Verloon de periode opnieuw om de aanpassingen door te voeren.">
                                <div
                                    class="part"
                                    [class.merged]="day.fg.value.dayType && day.fgSecond.value.dayType && index === 0">
                                    @if (!day.fg.value.dayType || !day.fgSecond.value.dayType) {
                                        <div class="cell wide">
                                            @if (day.hasUnapprovedRealisations) {
                                                <i
                                                    class="fa fa-triangle-exclamation me-2"
                                                    matTooltip="Er zijn niet goedgekeurde uren op deze dag"></i>
                                            }
                                            {{ day.date | date: (day.hasUnapprovedRealisations ? 'EEE' : 'EEEE') }}
                                        </div>
                                        <div class="cell wide">{{ day.date | date: 'dd-MM-yyyy' }}</div>
                                    }
                                    @if (day.fg.value.dayType && day.fgSecond.value.dayType) {
                                        @if (index === 0) {
                                            <div class="cell wide weekday">
                                                <div>
                                                    @if (day.hasUnapprovedRealisations) {
                                                        <i
                                                            class="fa fa-triangle-exclamation me-2"
                                                            matTooltip="Er zijn niet goedgekeurde uren op deze dag"></i>
                                                    }
                                                    {{
                                                        day.date
                                                            | date: (day.hasUnapprovedRealisations ? 'EEE' : 'EEEE')
                                                    }}
                                                </div>
                                            </div>

                                            <div class="cell wide date">
                                                <div>
                                                    {{ day.date | date: 'dd-MM-yyyy' }}
                                                </div>
                                            </div>
                                        }

                                        @if (index === 1) {
                                            <div class="cell wide"></div>
                                            <div class="cell wide"></div>
                                        }
                                    }
                                    <input class="cell wide daytype" [formControl]="fg.controls.dayType" type="text" />
                                </div>

                                <div class="part me-0">
                                    <input class="cell" [formControl]="fg.controls.begindate" type="text" />

                                    <input class="cell" [formControl]="fg.controls.enddate" type="text" />

                                    <app-minutes-input
                                        class="cell"
                                        [matTooltip]="
                                            fg.value.interruptions < 0
                                                ? 'Bij negatieve onderbrekingen zijn er overlappende uren geboekt'
                                                : ''
                                        "
                                        [formControl]="fg.controls.interruptions" />

                                    <app-minutes-input class="cell" [formControl]="fg.controls.hours" />

                                    <app-minutes-input class="cell" [formControl]="fg.controls.pause" />

                                    <app-minutes-input
                                        class="cell hours-to-reward"
                                        [correction]="-fg.value.notPaidHours"
                                        [formControl]="fg.controls.hoursToReward" />
                                </div>

                                <div class="buttons">
                                    @if (week.sendToAfas && !print) {
                                        <div
                                            class="week-button"
                                            (mouseover)="hoverWeekButton = week.weeknumber"
                                            (mouseout)="hoverWeekButton = null"
                                            matTooltip="Opties voor deze week">
                                            @if (first) {
                                                <button
                                                    [disabled]="week.settling || resettling || settling"
                                                    [matMenuTriggerFor]="weekMenu"
                                                    mat-icon-button
                                                    color="primary">
                                                    @if (!week.settling && !resettling) {
                                                        <i class="fa-light fa-ellipsis-vertical"></i>
                                                    } @else {
                                                        <i class="fas fa-arrows-rotate fa-spin"></i>
                                                    }
                                                </button>

                                                <mat-menu #weekMenu="matMenu">
                                                    <button
                                                        [disabled]="!canResettleWeek(week)"
                                                        (click)="resettlePeriod(week)"
                                                        mat-menu-item>
                                                        <i class="fa-light fa-rotate me-2"></i>
                                                        Opnieuw verrekenen
                                                    </button>

                                                    <button
                                                        [disabled]="week.settling"
                                                        (click)="removeWeek(week)"
                                                        mat-menu-item>
                                                        <i class="fa-light fa-trash me-2"></i>
                                                        Hele week terugdraaien
                                                    </button>
                                                </mat-menu>
                                            }
                                        </div>
                                    }

                                    @if (!week.sendToAfas && !print) {
                                        <div
                                            class="week-button"
                                            (mouseover)="hoverWeekButton = week.weeknumber"
                                            (mouseout)="hoverWeekButton = null"
                                            matTooltip="Hele week verrekenen">
                                            @if (first) {
                                                <button
                                                    [disabled]="week.settling || loading.length > 0"
                                                    (click)="settlePeriodHours(week)"
                                                    mat-icon-button
                                                    color="primary">
                                                    @if (!week.settling) {
                                                        <i class="fa-light fa-right-to-bracket"></i>
                                                    } @else if (week.settling) {
                                                        <i class="fas fa-arrows-rotate fa-spin"></i>
                                                    }
                                                </button>
                                            }
                                        </div>
                                    }

                                    @if (!print && !dayDisabled) {
                                        <div class="cell" [class.first]="first" [class.last]="last">
                                            <button
                                                class="hour-edit-button"
                                                [disabled]="week.settling"
                                                (click)="editHours(day.date, user().id)"
                                                mat-icon-button
                                                color="primary">
                                                @if (day.settling) {
                                                    <i class="fas fa-arrows-rotate fa-spin"></i>
                                                } @else if (!day.settling) {
                                                    <i class="fa-regular fa-user-pen"></i>
                                                }
                                            </button>
                                        </div>
                                    }
                                </div>

                                <div class="part">
                                    <app-minutes-input
                                        class="cell"
                                        [formControl]="fg.controls.normal"
                                        [class.abnormal]="fg.controls.normal?.value > 480" />
                                    <app-minutes-input class="cell" [formControl]="fg.controls.remaining" />
                                    <app-minutes-input class="cell" [formControl]="fg.controls.supplemented" />
                                    @if (!fg.controls.travelrealisations.value) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.traveltime" />
                                    }

                                    @if (fg.controls.travelrealisations.value) {
                                        <div class="cell" matTooltip="Werkelijke reistijd geschreven">
                                            <i class="fa-duotone fa-house-user"></i>
                                        </div>
                                    }

                                    @if (showTravelTo) {
                                        <div class="cell wide location">{{ index === 0 ? day.travelTo : '' }}</div>
                                    }

                                    @if (!caoBouwInfra) {
                                        <div class="cell">{{ fg.controls.travelcost.value | number: '0.0-2' }}</div>
                                    }
                                </div>

                                <div class="part">
                                    @if (caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.bonus30" />
                                    }

                                    @if (environment.periodSettlementColums['135V'] && !caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.bonus35" />
                                    }

                                    @if (environment.periodSettlementColums['145V'] && !caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.bonus45" />
                                    }

                                    <app-minutes-input class="cell" [formControl]="fg.controls.bonus50" />

                                    @if (environment.periodSettlementColums['200V']) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.bonus100" />
                                    }
                                </div>

                                <div class="part">
                                    @if (environment.periodSettlementColums[100]) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime100" />
                                    }

                                    @if (environment.periodSettlementColums[125] && caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime125" />
                                    }

                                    <app-minutes-input class="cell" [formControl]="fg.controls.overtime130" />

                                    @if (environment.periodSettlementColums[135] && !caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime135" />
                                    }

                                    @if (environment.periodSettlementColums[145] && !caoBouwInfra) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime145" />
                                    }

                                    @if (environment.periodSettlementColums[150]) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime150" />
                                    }

                                    <app-minutes-input class="cell" [formControl]="fg.controls.overtime150s" />

                                    @if (environment.periodSettlementColums['200Z']) {
                                        <app-minutes-input class="cell" [formControl]="fg.controls.overtime200s" />
                                    }

                                    <app-minutes-input class="cell" [formControl]="fg.controls.overtime200" />
                                </div>
                            </div>
                        }
                    }
                }
            </div>
        </div>
    }

    @if (fcNamePeriodTotalMap) {
        <div class="footer">
            <div class="part">
                <div class="cell wide triple"></div>
            </div>

            <div class="part me-0">
                <div class="cell large"></div>
                <div class="cell large"></div>
                <div class="cell large"></div>
                <div class="cell large">{{ fcNamePeriodTotalMap.get('hours') | minutes }}</div>
                <div class="cell large">{{ fcNamePeriodTotalMap.get('pause') | minutes }}</div>
                <div class="cell">
                    <div class="total">{{ fcNamePeriodTotalMap.get('hoursToReward') | minutes }}</div>
                    <span class="caption">Totaal</span>
                </div>
            </div>

            <div class="buttons">
                <div class="cell"></div>
            </div>

            <div class="part">
                <div class="cell">
                    <div class="total">{{ fcNamePeriodTotalMap.get('normal') | minutes }}</div>
                    <span class="caption">Contracturen</span>
                </div>
                <div class="cell large">{{ fcNamePeriodTotalMap.get('remaining') | minutes }}</div>
                <div class="cell large">{{ fcNamePeriodTotalMap.get('supplemented') | minutes }}</div>
                <div class="cell large">{{ fcNamePeriodTotalMap.get('traveltime') | minutes }}</div>
                @if (showTravelTo) {
                    <div class="cell large location"></div>
                }

                @if (!caoBouwInfra) {
                    <div class="cell">
                        <div class="total">{{ fcNamePeriodTotalMap.get('travelcost') | number: '0.0-3' }}</div>
                        <span class="caption">Kilometers</span>
                    </div>
                }
            </div>

            <div class="part">
                @if (caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('bonus30') | minutes }}</div>
                }

                @if (environment.periodSettlementColums['135V'] && !caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('bonus35') | minutes }}</div>
                }

                @if (environment.periodSettlementColums['145V'] && !caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('bonus45') | minutes }}</div>
                }

                <div class="cell large">{{ fcNamePeriodTotalMap.get('bonus50') | minutes }}</div>

                @if (environment.periodSettlementColums['200V']) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('bonus100') | minutes }}</div>
                }
            </div>

            <div class="part">
                @if (environment.periodSettlementColums[100]) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime100') | minutes }}</div>
                }

                @if (environment.periodSettlementColums[125] && caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime125') | minutes }}</div>
                }

                <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime130') | minutes }}</div>

                @if (environment.periodSettlementColums[135] && !caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime135') | minutes }}</div>
                }

                @if (environment.periodSettlementColums[145] && !caoBouwInfra) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime145') | minutes }}</div>
                }

                @if (environment.periodSettlementColums[150]) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime150') | minutes }}</div>
                }

                <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime150s') | minutes }}</div>

                @if (environment.periodSettlementColums['200Z']) {
                    <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime200s') | minutes }}</div>
                }

                <div class="cell large">{{ fcNamePeriodTotalMap.get('overtime200') | minutes }}</div>
            </div>
            <div class="part">
                <div class="cell">
                    <div class="total">{{ fcNamePeriodTotalMap.get('overtime') | minutes }}</div>
                    <span class="caption">Overuren</span>
                </div>
            </div>
        </div>
    }
</div>

@if (dayDetail) {
    <div class="day-details">
        <div class="head">
            <div class="row mx-0">
                <div class="col-12">
                    <h2>Geregistreerde uren {{ dayDetail.date | date: 'EEEE d MMMM yyyy' }}</h2>
                </div>
                <div class="col">
                    <h2>Resulterende verloningen {{ dayDetail.date | date: 'EEEE d MMMM yyyy' }}</h2>
                </div>
                <div class="col-auto">
                    <button (click)="dayDetail = null" mat-icon-button color="primary">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <table class="table">
                    <tr>
                        <th>Van / tot</th>
                        <th>Bron</th>
                        <th>Project</th>
                        <th>Opmerkingen</th>
                        <th>Uursoort</th>
                        <th class="text-end">Aangepast</th>
                    </tr>
                    @for (realisation of dayDetail.realisations; track realisation.id) {
                        <tr>
                            <td class="text-nowrap">
                                {{ realisation.begindate | date: 'EE HH:mm' }} -
                                {{ realisation.enddate | date: 'EE HH:mm' }}
                                @if (realisation.pause > 0) {
                                    ({{ realisation.pause | minutes }} pauze)
                                }
                            </td>
                            <td class="text-nowrap">
                                @if (realisation.user_planning_id) {
                                    Personeelsplanning
                                }
                                @if (realisation.planning_has_entity_id) {
                                    Transportplanning
                                }
                                @if (
                                    realisation.planning_id &&
                                    !realisation.user_planning_id &&
                                    !realisation.planning_has_entity_id
                                ) {
                                    {{ environment.rootPageName }}
                                }

                                @if (realisation.leave_id) {
                                    Verlof
                                }

                                @if (realisation.afas_project_id) {
                                    Handmatig toegevoegd
                                }
                            </td>
                            <td class="text-nowrap">
                                {{
                                    realisation.afas_project_id ??
                                        realisation.planning_has?.afas_project_id ??
                                        realisation.user_planning?.afas_project_id ??
                                        realisation.project?.afas_project_id ??
                                        realisation.planning?.worknumber
                                }}
                            </td>
                            <td>
                                {{ realisation.comment_user }}
                                {{ realisation.comment_manager }}
                                {{ realisation.planning_has?.comment }}
                                {{ realisation.user_planning?.comment }}
                            </td>
                            <td class="text-nowrap">
                                {{ realisation.hourtype | hourtype }}
                            </td>
                            <td class="text-nowrap text-end">
                                {{ realisation.updated_at | date: 'EEE d MMM yyyy H:mm' }}
                            </td>
                        </tr>
                    }
                </table>
            </div>
            <div class="col">
                <table class="table">
                    <tr>
                        <th class="text-end">Cumulatief</th>
                        <th class="text-end">Aantal</th>
                        <th>Uursoort</th>
                        <th>Beschrijving (van / tot)</th>
                        <th class="text-end">Aangepast</th>
                    </tr>
                    @for (settlement of dayDetail.settlements; track settlement.id) {
                        @let realisation =
                            dayDetail.realisations | realisationForSettlement: settlement.realisation?.id;
                        @let cumulativeAmount = dayDetail.settlements | cumulativeSettlementAmount: settlement.id;
                        @let cumulativeMinutes = dayDetail.settlements | cumulativeSettlementMinutes: settlement.id;

                        @let muted =
                            settlement.hourtype.description.toLowerCase().includes('toeslag') ||
                            settlement.hourtype.description.toLowerCase().includes('verschoven');

                        @let title =
                            realisation
                                ? (realisation?.hourtype | hourtype) +
                                  ' ' +
                                  (realisation?.begindate | date: 'EE HH:mm') +
                                  ' - ' +
                                  (realisation?.enddate | date: 'EE HH:mm') +
                                  (realisation
                                      ? realisation?.pause > 0
                                          ? ' (' + (realisation?.pause | minutes) + ' pauze)'
                                          : ''
                                      : '')
                                : '';

                        <tr>
                            <td class="text-nowrap text-end" [class.text-muted]="muted">
                                @if (settlement.hourtype_code === 'CRW') {
                                    {{ cumulativeAmount | number }} km
                                } @else {
                                    {{ cumulativeMinutes | minutes }}
                                }
                            </td>

                            <td class="text-nowrap text-end" [class.text-muted]="muted">
                                @if (settlement.hourtype_code === 'CRW') {
                                    {{ settlement.amount | number }} km
                                } @else {
                                    {{ settlement.minutes | minutes }}
                                }
                            </td>

                            <td class="text-nowrap" [title]="title">
                                {{ settlement.hourtype?.description }} ({{ settlement.hourtype?.code }})
                            </td>

                            <td [title]="title">
                                {{ settlement.description }}
                            </td>

                            <td class="text-nowrap text-end">
                                {{ settlement.updated_at | date: 'EEE d MMM yyyy H:mm' }}
                            </td>
                        </tr>
                    }
                </table>
            </div>
        </div>
    </div>
}
